import React, { useContext } from 'react';

import { ArchivalAidDetail } from 'modules/archival-aid/archival-aid-detail';

import { EadDetail } from 'modules/archival-aid/ead-detail/EadDetail';
import { useArchivalAidDetail } from './hooks/aid-detail-hook';
import { useEadDetail } from './hooks/ead-detail-hook';

import { ArchivalUnitDetail } from 'modules/archival-unit/archival-unit-detail';
import { useArchivalUnitDetail } from './hooks/archival-unit-detail-hook';

import { ArchivalCollectionDetail } from 'modules/archival-collection/archival-collection-detail';
import { useArchivalCollectionDetail } from './hooks/archival-collection-hook';

import { HierarchyContext } from './context/hierarchy-context';
import { BreadcrumbsContext } from './context/curmbs-context';

const EmptyBody = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: 'calc(60vh)',
    }}
  >
    <div
      style={{
        opacity: 0.2,
        background: `url(${process.env.PUBLIC_URL}/archiv.png)`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        height: 150,
        width: '100%',
        backgroundPosition: 'center',
      }}
    />
  </div>
);

export const ArchivalAidBody = () => {
  const { archivalAidId, eadId, archivalUnitId } = useContext(HierarchyContext);
  const breadcrumbs = useContext(BreadcrumbsContext);

  const eadResponse = useEadDetail(eadId);
  const aidResponse = useArchivalAidDetail(archivalAidId);
  const auResponse = useArchivalUnitDetail(archivalUnitId);

  const isLoading =
    aidResponse.isLoading || auResponse.isLoading || eadResponse.isLoading;

  if (isLoading) {
    return <></>;
  }

  if (!archivalAidId) {
    return <EmptyBody />;
  }

  if (eadId && breadcrumbs.length > 1) {
    return <EadDetail item={eadResponse.data} />;
  }
  if (archivalUnitId) {
    return <ArchivalUnitDetail item={auResponse.data} />;
  }

  return <ArchivalAidDetail item={aidResponse.data} />;
};

export const ArchivalCollectionGridBody = () => {
  const {
    archivalAidId,
    eadId,
    archivalUnitId,
    archivalCollectionId,
  } = useContext(HierarchyContext);
  const breadcrumbs = useContext(BreadcrumbsContext);

  const collectionResponse = useArchivalCollectionDetail(archivalCollectionId);
  const aidResponse = useArchivalAidDetail(archivalAidId);
  const archivalUnitResponse = useArchivalUnitDetail(archivalUnitId);
  const eadResponse = useEadDetail(eadId);

  const isLoading =
    collectionResponse.isLoading ||
    aidResponse.isLoading ||
    archivalUnitResponse.isLoading ||
    eadResponse.isLoading;

  if (isLoading) {
    return <></>;
  }

  if (!archivalCollectionId) {
    return <EmptyBody />;
  }

  if (eadId && breadcrumbs.length > 2) {
    return <EadDetail item={eadResponse.data} />;
  }
  if (archivalUnitId) {
    return <ArchivalUnitDetail item={archivalUnitResponse.data} />;
  }
  if (archivalAidId) {
    return <ArchivalAidDetail item={aidResponse.data} />;
  }

  return <ArchivalCollectionDetail item={collectionResponse.data} />;
};
